import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/user-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-5534218e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "user-icon",
  width: "24",
  height: "24"
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.computedUser)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["logo-and-name data d-flex align-items-center", { 'logo-and-name-row-view': _ctx.rowView, 'logo-and-name-small': _ctx.smallAvatarSize, 'logo-and-name-middle': _ctx.middleAvatarSize }])
        }, [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.computedUser.avatar)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.computedUser.avatar,
                  alt: "avatar"
                }, null, 8, _hoisted_2))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(["initials-avatar-wrapper d-flex align-items-center justify-content-center", { 'is-placeholder': _ctx.isPlaceholder }])
                }, [
                  _createElementVNode("p", {
                    class: _normalizeClass(["initials d-flex align-items-center justify-content-center m-0", { 'initials-row-view': _ctx.rowView, 'initials-small': _ctx.smallAvatarSize, 'initials-middle': _ctx.middleAvatarSize }])
                  }, _toDisplayString(_ctx.getInitials(_ctx.user)), 3)
                ], 2))
          ]),
          _createElementVNode("div", null, [
            (_ctx.computedUser.placeholderId)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("p", {
                    class: _normalizeClass(["data", { 'mb-0 data-row-view': _ctx.rowView }])
                  }, _toDisplayString(_ctx.computedUser.name) + " (Placeholder) ", 3)
                ]))
              : (_ctx.computedUser.data?.firstName || _ctx.computedUser.data?.lastName)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("p", {
                      class: _normalizeClass(["data", { 'mb-0 data-row-view': _ctx.rowView }])
                    }, _toDisplayString(_ctx.computedUser.data?.firstName + " " + _ctx.computedUser.data?.lastName), 3),
                    (_ctx.computedUser.data?.role)
                      ? (_openBlock(), _createElementBlock("p", {
                          key: 0,
                          class: _normalizeClass(["data role", { 'mb-0 data-row-view': _ctx.rowView }])
                        }, _toDisplayString(_ctx.computedUser.data?.role), 3))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("p", {
                      class: _normalizeClass(["data", { 'mb-0 data-row-view': _ctx.rowView }])
                    }, _toDisplayString(_ctx.computedUser.email), 3),
                    (_ctx.computedUser.data?.role)
                      ? (_openBlock(), _createElementBlock("p", {
                          key: 0,
                          class: _normalizeClass(["data role", { 'mb-0 data-row-view': _ctx.rowView }])
                        }, _toDisplayString(_ctx.computedUser.data?.role), 3))
                      : _createCommentVNode("", true)
                  ]))
          ])
        ], 2))
      : _createCommentVNode("", true),
    (!_ctx.computedUser)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
      : _createCommentVNode("", true)
  ], 64))
}